<template>
  <div class="modify-amount-page"  data-test="multi-modify-amount">
    <div class="main">
      <choosed-nav :len="courseArrangeIds.length" /> 
      <van-cell :title="`老师授课${lessonUnit}数`" style="margin-top: 24px;">
        <template>
          <van-stepper v-model="courseAmount" step="0.5" min="0.5" max="99999" input-width="60" :decimal-length="1"/>
        </template>
      </van-cell>
    </div>
    <div class="footer">
      <van-button 
        square round 
        block 
        type="primary" 
        data-test="multi-modify-amount-btn-save"
        @click="submitConfirm">
          保存
        </van-button>
    </div>
  </div>
</template>

<script>
import choosedNav from './choosed-nav.vue';

export default {
  name: "multiModifyAmount",
  components:{
    choosedNav,
  },
  data() {
    return {
      pageTitle: "修改数量",
      courseAmount: 1,
      courseArrangeIds: [],
    }
  },
  computed:{
    ...Vuex.mapState(['lessonUnit']),
  },
  created () {
    Object.assign(this, app.ls.get("multi-modify-amount-obj"));
  },
  methods: {
    submitConfirm () {

      vant.Dialog.confirm({message: '确定保存？', confirmButtonText: '确定'})
        .then(()=>{
          this.submit();
        })
        .catch(err=> {
          console.log('取消了。。')
        })

    },
    submit() {
      this.showLoading();
      this.$api.batchModifyCourseAmount({
        courseArrangeIds: this.courseArrangeIds,
        courseAmount: this.courseAmount,
      }).then(res=>{
        if (res.code === 200) {
          app.vue.$emit("refresh-multi-edit-page");
          vant.Toast.success( "修改成功");
          setTimeout(()=>{
            this.$router.back();
          }, 300)
        }
      })
    },
  },
};
</script>

<style lang="scss" scoped>
.modify-amount-page {
  display: flex;
  flex-direction: column;
  .main {
    flex: 1;
    overflow-y: auto;
  }
  .footer {
    height: calc(var(--w) * 50);
    background: var(--white);
    padding: calc(var(--gap) * 5) calc(var(--gap) * 16);
    display: flex;
    .van-button {
      height: calc(var(--w) * 40);
    }
  }
}
</style>